import {Auditoria} from "../../bibliotecaPjus/models/comum.models";
import {IFormulario, IModel} from "../../bibliotecaPjus/models/contrato.models";
import {Negociacao} from "./negociacao.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {LIMITES_CARACTERES} from "../helper/limites-caracteres.const";

export class CancelarPropostaModel extends Auditoria implements IModel, IFormulario {

  propostaId: string;
  mensagemId: number;
  observacao: string;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.propostaId = other.propostaId;
      this.mensagemId = other.mensagemId;
      this.observacao = other.observacao;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        propostaId: new FormControl(this.propostaId, [Validators.required]),
        mensagemId: new FormControl(0, [Validators.required]),
        observacao: new FormControl(this.observacao, [Validators.maxLength(LIMITES_CARACTERES.OBSERVACAO)]),
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }
}

